import { useRef, useState, useEffect } from "react";
import observeRect from "@reach/observe-rect";

export default function useRect(nodeRef, observe = true) {
  let observerRef = useRef(null);
  let [rect, setRect] = useState(null);
  useEffect(
    () => {
      observerRef.current = observeRect(nodeRef.current, setRect);
      if (observe) {
        observerRef.current.observe();
      }
      return () => observerRef.current.unobserve();
    },
    [observe]
  );
  return rect;
}



// WEBPACK FOOTER //
// ./src/useRect.js